import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { SpColorPickerModule } from '@components/sp-color-picker/src/sp-color-picker.module';
import { SpFormControlsModule } from '@components/sp-form-controls';

import { SpCustomButtonComponent } from '@components/sp-custom-button/sp-custom-button.component';

import { SpAdvancedRadiusSettingsModule } from '@components/sp-advanced-radius-settings';

import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        SpColorPickerModule,
        SpFormControlsModule,
        TooltipModule,
        SpAdvancedRadiusSettingsModule,
        SpCustomButtonComponent,
    ],
    exports: [SpCustomButtonComponent],
})
export class SpCustomButtonModule {}
